export default "__VITE_ASSET__Dw_dxFjN__"